import React, { useMemo, useState, useEffect } from 'react';
import appState from '@bingads-webui-component-legacy/state/index';
import { parseSync } from '@bingads-webui/safe-json';
import { InlineDownloadWrapper } from '../inline-download-wrapper';

const getReportEmailRule = () => {
  const rule = appState.get('$ReportEmailRule');
  appState.unset('$ReportEmailRule');
  return rule;
};

export const useInlineDownload = ({ overwriteFilters }) => {
  // ReportEmailRule state from appState is for the filter, columns and date range from the task
  // items of the report grid. We need to get it from appState and then remove it from appState
  // so that it doesn't get used in next show of the inline download.
  const ReportEmailRule = getReportEmailRule();
  const [isDownloadShown, setDownloadShown] = useState(!!ReportEmailRule);
  const ReportEmailRuleSnapshot = useMemo(() => ReportEmailRule, [isDownloadShown]);

  // Ensure not rerendering root after mount
  const renderInlineDownload = useMemo(
    () => props => (<InlineDownloadWrapper {...props} ReportEmailRule={ReportEmailRuleSnapshot} />),
    [ReportEmailRuleSnapshot]
  );

  useEffect(() => {
    if (ReportEmailRuleSnapshot && ReportEmailRuleSnapshot.Filter && overwriteFilters) {
      // Filter is a stringified JSON object in the serializedFilter of the inline download API call.
      // We need to parse it and then overwrite the filters in the grid with the parsed filters.
      const filters = parseSync(ReportEmailRuleSnapshot.Filter);
      overwriteFilters(filters);
    }
  }, [overwriteFilters]);

  return {
    renderInlineDownload,
    ReportEmailRule,
    isDownloadShown,
    setDownloadShown,
  };
};
